module.exports = __webpack_public_path__ + "media/block_inside.e7f70128.wav";